import * as yup from 'yup';

export const schema = yup.object({
  claId: yup.number().required(),
  dutyTypeDynClaId: yup.number().required(),
  dutyTypeDynId: yup.number().required(),
  claCode: yup.string().required(),
  dutyTypeDyn: yup.object({
    valid: yup.object({
      from: yup.date().required().nullable().default(null),
      to: yup.date().required().nullable().default(null)
    }),
    code: yup.string().required(),
    dccSvc: yup.string().required(),
    description: yup.string().required()
  }),
  hcYhsLc: yup.string().optional(),
  hcYhsLcSec: yup.string().optional(),

  hcPayLc: yup.string().optional(),
  hcPayLcSec: yup.string().optional(),

  zhcYhsLc: yup.string().optional(),
  zhcYhsLcSec: yup.string().optional(),

  zhcPayLc: yup.string().optional(),
  zhcPayLcSec: yup.string().optional()
});
